"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const api_1 = require("@react-google-maps/api");
const react_markdown_1 = __importDefault(require("react-markdown"));
const remark_gfm_1 = __importDefault(require("remark-gfm"));
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
const googleMaps_config_1 = require("../../config/googleMaps.config");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const InputLoading_1 = __importDefault(require("../inputs/InputLoading"));
const coordinatesToLatLng = (coordinates) => ({
    lat: coordinates[1],
    lng: coordinates[0]
});
const InfoMap = (props) => {
    var _a, _b, _c;
    // Set the google map config once, as it cannot be changed after it is
    // loaded (for language change for example). see
    // https://stackoverflow.com/questions/7065420/how-can-i-change-the-language-of-google-maps-on-the-run
    const googleMapConfig = react_1.default.useMemo(() => (0, googleMaps_config_1.getCurrentGoogleMapConfig)(props.i18n.language), []);
    const { isLoaded } = (0, api_1.useJsApiLoader)(googleMapConfig);
    const [map, setMap] = react_1.default.useState(null);
    const [center, setCenter] = react_1.default.useState({
        lat: project_config_1.default.mapDefaultCenter.lat,
        lng: project_config_1.default.mapDefaultCenter.lon
    });
    (0, react_1.useEffect)(() => {
        const configDefaultCenter = surveyHelper.parse(props.widgetConfig.defaultCenter, props.interview, props.path, props.user);
        const defaultCenter = configDefaultCenter
            ? { lat: configDefaultCenter.lat, lng: configDefaultCenter.lon }
            : { lat: project_config_1.default.mapDefaultCenter.lat, lng: project_config_1.default.mapDefaultCenter.lon };
        setCenter(defaultCenter);
    }, [props.widgetConfig.defaultCenter]);
    const onMapReady = react_1.default.useCallback((map) => {
        map.panTo(center);
        setMap(map);
    }, []);
    const onUnmount = react_1.default.useCallback(() => {
        setMap(null);
    }, []);
    const onZoomChange = () => {
        if (!map)
            return;
        const currentZoom = map.getZoom();
        if (currentZoom && props.widgetConfig.maxZoom && props.widgetConfig.maxZoom < currentZoom) {
            map.setZoom(props.widgetConfig.maxZoom);
        }
    };
    if (!props.widgetStatus.isVisible) {
        return null;
    }
    if (!isLoaded) {
        return react_1.default.createElement(InputLoading_1.default, null);
    }
    const title = surveyHelper.translateString(props.widgetConfig.title, props.i18n, props.interview, props.path, props.user) ||
        '';
    const geojsons = props.widgetConfig.geojsons(props.interview, props.path, undefined);
    const gMarkers = [];
    const gPolylines = [];
    const gPolygons = [];
    const points = ((_a = geojsons.points) === null || _a === void 0 ? void 0 : _a.features) || [];
    const linestrings = ((_b = geojsons.linestrings) === null || _b === void 0 ? void 0 : _b.features) || [];
    const polygons = ((_c = geojsons.polygons) === null || _c === void 0 ? void 0 : _c.features) || [];
    const linestringColor = props.widgetConfig.linestringColor || '#0000ff';
    const linestringActiveColor = props.widgetConfig.linestringActiveColor || '#00ff00';
    const bounds = new google.maps.LatLngBounds();
    for (let i = 0, countI = points.length; i < countI; i++) {
        const point = points[i];
        const gLatLng = new google.maps.LatLng(point.geometry.coordinates[1], point.geometry.coordinates[0]);
        const markerParams = {
            position: gLatLng,
            draggable: false
        };
        if (point.properties.icon) {
            markerParams.icon = {
                url: point.properties.icon.url,
                size: new google.maps.Size(point.properties.icon.size[0], point.properties.icon.size[1]),
                scaledSize: new google.maps.Size(point.properties.icon.size[0], point.properties.icon.size[1])
            };
        }
        gMarkers.push(react_1.default.createElement(api_1.Marker, Object.assign({ key: `gMarker_infoMap_${props.path}__${i}` }, markerParams)));
        if (bounds) {
            bounds.extend({ lat: gLatLng.lat(), lng: gLatLng.lng() });
        }
    }
    for (let i = 0, countI = linestrings.length; i < countI; i++) {
        const linestring = linestrings[i];
        const polylineCoordinates = linestring.geometry.coordinates.map((coordinates) => ({
            lat: coordinates[1],
            lng: coordinates[0]
        }));
        const gArrowWhite = {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            strokeColor: '#ffffff',
            strokeOpacity: 0.8,
            strokeWeight: 5,
            scale: 2,
            fillColor: '#ffffff',
            fillOpacity: 0.8
        };
        const gArrowBlack = {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            strokeColor: '#000000',
            strokeOpacity: 0.4,
            strokeWeight: 7,
            scale: 2,
            fillColor: '#000000',
            fillOpacity: 0.4
        };
        const gArrow = {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            strokeColor: linestring.properties && linestring.properties.active ? linestringActiveColor : linestringColor,
            strokeOpacity: 0.6,
            strokeWeight: 3,
            scale: 2,
            fillColor: linestring.properties && linestring.properties.active ? linestringActiveColor : linestringColor,
            fillOpacity: 0.6
        };
        gPolylines.push(react_1.default.createElement(api_1.Polyline, { key: `gPolyline_infoMap_black_${props.path}__${i}`, path: polylineCoordinates, options: {
                strokeColor: '#000000',
                strokeWeight: 7,
                strokeOpacity: 0.4,
                icons: [
                    {
                        icon: gArrowBlack,
                        offset: '50%'
                    }
                ],
                zIndex: Math.ceil((1000.0 / i) * 1000.0) || 300
            } }));
        gPolylines.push(react_1.default.createElement(api_1.Polyline, { key: `gPolyline_infoMap_white_${props.path}__${i}`, path: polylineCoordinates, options: {
                strokeColor: '#ffffff',
                strokeWeight: 5,
                strokeOpacity: 0.8,
                icons: [
                    {
                        icon: gArrowWhite,
                        offset: '50%'
                    }
                ],
                zIndex: Math.ceil((1000.0 / i) * 1000.0) || 400
            } }));
        gPolylines.push(react_1.default.createElement(api_1.Polyline, { key: `gPolyline_infoMap_${props.path}__${i}`, path: polylineCoordinates, options: {
                strokeColor: linestring.properties && linestring.properties.active ? linestringActiveColor : linestringColor,
                strokeWeight: 3,
                strokeOpacity: 0.4,
                icons: [
                    {
                        icon: gArrow,
                        offset: '50%'
                    }
                ],
                zIndex: Math.ceil((1000.0 / i) * 1000.0) || 500
            } }));
    }
    for (let i = 0, countI = polygons.length; i < countI; i++) {
        const polygon = polygons[i];
        if (polygon.geometry.type === 'Polygon') {
            // For Polygon: coordinates is an array of rings (outer ring + holes)
            // Map all rings: coordinates[0] is outer boundary, coordinates[1+] are holes
            const polygonCoordinates = polygon.geometry.coordinates.map((ring) => ring.map(coordinatesToLatLng));
            gPolygons.push(react_1.default.createElement(api_1.Polygon, { key: `gPolygon_infoMap_${props.path}__${i}`, paths: polygonCoordinates, options: {
                    strokeColor: polygon.properties.strokeColor || '#0000FF',
                    strokeOpacity: polygon.properties.strokeOpacity || 0.8,
                    strokeWeight: polygon.properties.strokeWeight || 2,
                    fillColor: polygon.properties.fillColor || '#0000FF',
                    fillOpacity: polygon.properties.fillOpacity || 0.35
                } }));
        }
        else if (polygon.geometry.type === 'MultiPolygon') {
            // For MultiPolygon: coordinates is an array of polygons, each with their rings
            // We need to create a separate Polygon component for each polygon in the MultiPolygon
            polygon.geometry.coordinates.forEach((polyCoords, polyIndex) => {
                const polygonCoordinates = polyCoords.map((ring) => ring.map(coordinatesToLatLng));
                gPolygons.push(react_1.default.createElement(api_1.Polygon, { key: `gPolygon_infoMap_${props.path}__${i}_${polyIndex}`, paths: polygonCoordinates, options: {
                        strokeColor: polygon.properties.strokeColor || '#0000FF',
                        strokeOpacity: polygon.properties.strokeOpacity || 0.8,
                        strokeWeight: polygon.properties.strokeWeight || 2,
                        fillColor: polygon.properties.fillColor || '#0000FF',
                        fillOpacity: polygon.properties.fillOpacity || 0.35
                    } }));
            });
        }
        if (bounds &&
            polygon.properties.minLat &&
            polygon.properties.maxLat &&
            polygon.properties.minLong &&
            polygon.properties.maxLong) {
            bounds.extend({ lat: polygon.properties.minLat, lng: polygon.properties.minLong });
            bounds.extend({ lat: polygon.properties.maxLat, lng: polygon.properties.maxLong });
            bounds.extend({ lat: polygon.properties.minLat, lng: polygon.properties.maxLong });
            bounds.extend({ lat: polygon.properties.maxLat, lng: polygon.properties.minLong });
        }
    }
    if (map && bounds) {
        map.fitBounds(bounds);
    }
    return (react_1.default.createElement("div", { className: "survey-info-map__map-container" },
        react_1.default.createElement("div", { className: "infoMap-title" },
            react_1.default.createElement(react_markdown_1.default, { remarkPlugins: [[remark_gfm_1.default, { singleTilde: false }]] }, title)),
        react_1.default.createElement(api_1.GoogleMap, { id: "info-map", mapContainerStyle: {
                boxSizing: 'border-box',
                position: 'relative',
                width: '100%',
                height: props.widgetConfig.height || '400px',
                border: '1px solid rgba(0,0,0,0.2'
            }, center: center, onLoad: onMapReady, onUnmount: onUnmount, onZoomChanged: onZoomChange, clickableIcons: false, zoom: props.widgetConfig.defaultZoom || 10 },
            gMarkers,
            gPolylines,
            gPolygons)));
};
exports.default = (0, react_i18next_1.withTranslation)()(InfoMap);
//# sourceMappingURL=InfoMap.js.map